// Icons
import Tournament from "assets/icons/glory/burger_tournament.svg?react";
import Invite from "assets/icons/glory/burger_invite.svg?react";
import GiftBanger from "assets/icons/banger/banger-menu-gift.svg?react";
import Chart from "assets/icons/chart.svg?react";
import SportIcon from "assets/icons/sport.svg?react";

// import GameHistory from "assets/icons/game-history.svg?react";
// import WelcomeBonus from "assets/icons/glory/casino_tip.svg?react";
// import Categories from "assets/icons/categories.svg?react";
// import Support from "assets/icons/support.svg?react";
// import Invite from "assets/icons/glory/burger_invite.svg?react";

// import PersonOutline from "assets/icons/glory/burger_account.svg?react";
// import Transactions from "assets/icons/glory/burger_transaction.svg?react";
// import TimeRevert from "assets/icons/glory/burger_history.svg?react";
// import AviatorLogo from "assets/icons/glory/burger_avia.svg?react";
// import HistoryGamesIcon from "assets/icons/glory/history-games.svg?react";
// Url
import url from "url/index";

export type MOBILE_NAVIGATION_ITEM_TYPE = {
  id: MOBILE_NAVIGATION_ENUMS;
  name: string;
  nameImage?: JSX.Element;
  icon: JSX.Element;
  customColor?: string;
  url: string;
};

export enum MOBILE_NAVIGATION_ENUMS {
  HOME,
  WELCOME_BONUS,
  SUPPORT,
  TOURNAMEMTNS,
  AVIATOR,
  JACKPOT,
  PROFILE,
  TRANSACTIONS_HISTORY,
  GAMES_HISTORY,
  MY_BONUS,
  ACCESS_RECOVERY,
  INVITE_FRIEND,
  CATEGORIES,
  PERSONAL_DATA,
  PASSWORD,
  ACCOUNT,
  TRANSACTIONS,
  ACHIEVMENTS,
  BONUS,
  NOTIFICATION,
  INVITE,
  SPORT,
}

// export const MOBILE_NAVIGATION_NOT_AUTH: MOBILE_NAVIGATION_ITEM_TYPE[] = [
//   {
//     id: MOBILE_NAVIGATION_ENUMS.WELCOME_BONUS,
//     name: "menu.left.welcomebonus",
//     icon: <WelcomeBonus />,
//     url: url.routes.info.welcomeBonus(),
//   },
//   {
//     id: MOBILE_NAVIGATION_ENUMS.INVITE,
//     name: "profile.account.invite",
//     icon: <Invite />,
//     url: url.routes.profile.inviteFriend(),
//   },
//   {
//     id: MOBILE_NAVIGATION_ENUMS.TOURNAMEMTNS,
//     name: "menu.left.tournament",
//     icon: <Tournament />,
//     url: url.routes.tournament.index(),
//   },
//   {
//     id: MOBILE_NAVIGATION_ENUMS.SUPPORT,
//     name: "burger.menu.support",
//     icon: <Support />,
//     url: "",
//   },
// {
//   id: MOBILE_NAVIGATION_ENUMS.AVIATOR,
//   name: "",
//   nameImage: <AviatorName />,
//   icon: <AviatorLogo />,
//   customColor: " ",
//   url: "b771a7c4f2285943a1d7562bbe6ce05f",
// },
// {
//   id: MOBILE_NAVIGATION_ENUMS.CATEGORIES,
//   name: "casino.providers.category",
//   icon: <Categories />,
//   url: url.routes.profile.bonus(),
// },
// ];

// export const MOBILE_NAVIGATION_AUTH: MOBILE_NAVIGATION_ITEM_TYPE[] = [
//   {
//     id: MOBILE_NAVIGATION_ENUMS.PROFILE,
//     name: "menu.left.profile",
//     icon: <PersonOutline />,
//     url: url.routes.profile.index(),
//   },
//   {
//     id: MOBILE_NAVIGATION_ENUMS.INVITE_FRIEND,
//     name: "profile.account.invite",
//     icon: <Invite />,
//     url: url.routes.profile.inviteFriend(),
//   },
//   {
//     id: MOBILE_NAVIGATION_ENUMS.TRANSACTIONS_HISTORY,
//     name: "menu.left.transactions.history",
//     icon: <Transactions />,
//     url: url.routes.profile.transactionDetail("deposit"),
//   },
//   {
//     id: MOBILE_NAVIGATION_ENUMS.GAMES_HISTORY,
//     name: "menu.left.games.history",
//     icon: <HistoryGamesIcon />,
//     url: url.routes.profile.gamesHistory(),
//   },
//   {
//     id: MOBILE_NAVIGATION_ENUMS.MY_BONUS,
//     name: "menu.left.mybonus",
//     icon: <MyBonus />,
//     url: url.routes.profile.bonus(),
//   },
// {
//   id: MOBILE_NAVIGATION_ENUMS.GAMES_HISTORY,
//   name: "menu.left.games.history",
//   icon: <HistoryGamesIcon />,
//   url: url.routes.profile.gamesHistory(),
// },
// ];

export const SIDEBAR_AUTH_MOBILE_NAVIGATION: MOBILE_NAVIGATION_ITEM_TYPE[] = [
  {
    id: MOBILE_NAVIGATION_ENUMS.INVITE_FRIEND,
    name: "profile.account.invite",
    icon: <Invite />,
    url: url.routes.profile.inviteFriend(),
  },
  {
    id: MOBILE_NAVIGATION_ENUMS.WELCOME_BONUS,
    name: "menu.left.welcomebonus",
    icon: <GiftBanger />,
    url: url.routes.info.welcomeBonus(),
  },
  {
    id: MOBILE_NAVIGATION_ENUMS.SPORT,
    icon: <SportIcon />,
    name: "casino.top.sports",
    url: url.config.casino.sportsBook,
  },
  {
    id: MOBILE_NAVIGATION_ENUMS.TOURNAMEMTNS,
    name: "menu.left.tournament",
    icon: <Tournament />,
    url: url.routes.tournament.index(),
  },
  {
    id: MOBILE_NAVIGATION_ENUMS.SUPPORT,
    name: "burger.menu.support",
    icon: <Chart />,
    url: "",
  },
];

export const SIDEBAR_NOT_AUTH_MOBILE_NAVIGATION: MOBILE_NAVIGATION_ITEM_TYPE[] =
  SIDEBAR_AUTH_MOBILE_NAVIGATION.filter(
    (nav) => nav.id !== MOBILE_NAVIGATION_ENUMS.INVITE_FRIEND,
  );
